export enum Permission {
  RetailerCredentialManagementView = 'retailer_credential_management.view',
  RetailerCredentialManagementModify = 'retailer_credential_management.modify',
}
